
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import FloatingButtons from './components/feature/FloatingButtons'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <FloatingButtons />
    </BrowserRouter>
  )
}

export default App
